<template>
  <div class="cim-style">
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="email">
        <!-- 邮箱 -->
        <BaseInput
          v-model="form.email"
          :autofocus="!isMobile"
          @blur="setAccount(form.email)"
          @keyup.enter.native="next"
          :validate-event="Boolean(form.email)"
          :placeholer="'Enter the Email'"
        />
      </el-form-item>
    </el-form>
    <el-button
      class="button-custom"
      @click="next"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.continue`,
      }"
      >{{ $t('login.loginPage.continue') }}</el-button
    >
    <!-- <BaseLine :text="$t('login.register.or')" /> -->
    <OtherLogin />
  </div>
</template>
<script>
import BaseInput from '@/components/common/BaseInput.vue'
// import BaseLine from '@/components/common/BaseLine'
import OtherLogin from '@/components/login/OtherLogin'
import BaseMixin from '@/mixins/BaseMixin'
import AccountMixins from '@/mixins/AccountMixins.js'
import LoginStepAccountMixin from '../mixins/LoginStepAccountMixin'
import store from '@/store'
import { checkPorscheEmail } from '../valid'
import { mapGetters } from 'vuex'
export default {
  components: {
    BaseInput,
    // BaseLine,
    OtherLogin,
  },
  mixins: [BaseMixin, AccountMixins, LoginStepAccountMixin],
  props: {},
  data() {
    return {
      form: {
        email: '',
      },
      submitDisabled: false,
    }
  },
  computed: {
    ...mapGetters(['currentAccount']),
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t('login.register.inputEmail'),
          },
          {
            validator: async (rule, value, callback) => {
              if (checkPorscheEmail(value.toLowerCase())) {
                try {
                  let { data } = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = false
                    return callback(
                      new Error(this.$t('login.register.notExists'))
                    )
                  } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = true
                    return callback()
                  }
                } catch (error) {
                  return callback()
                }
              }

              return callback(
                new Error('Please enter the correct E-mail address')
              )
            },
            trigger: 'blur',
          },
        ],
      }
    },
  },
  watch: {
    'form.email': {
      handler: function (newVal) {
        this.submitDisabled = !newVal
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.form['email'] = this.currentAccount
  },
  methods: {
    setAccount(value) {
      const result = checkPorscheEmail(value)
      if (result) {
        this.$store.commit('setCurrentAccount', value)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.cim-style {
  padding-bottom: 40px;
}
</style>
